// extracted by mini-css-extract-plugin
export default {"container":"styles_container__xy3k6","icon":"styles_icon__cIyRX","littleButton":"styles_littleButton__uKEGf","input":"styles_input__fhWfy"};